import { render } from "./Video.vue?vue&type=template&id=0e179e08&ts=true&lang=pug"
import script from "./Video.vue?vue&type=script&setup=true&lang=ts"
export * from "./Video.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__